// Alt innhold som er spesielt for denne boka. Resten av koden er lik i begge
// fargeleggingsbøkene.

export const book = {
  id: 'dukkehjem',
  title: 'Et dukkehjem',
  pdfFileName: 'Et dukkehjem – referat.pdf',
  cover: {
    imageUrl: './unnamed.png',
    intro: 'Fortell historien om Et dukkehjem med egne ord – ett bilde om gangen.',
    steps: [
      'Se på bildet og tenk over hva som skjer.',
      'Skriv et kort referat og fargelegg bildet.',
      'Lag en PDF når du er ferdig, og lever den.',
    ],
  },
  // mode 'referat': eleven skriver hva som skjer på bildet. text er hjelpen bak
  // «Står du fast?», words er støtteordene, title brukes i sideoversikten.
  pages: [
    {
      mode: 'referat', title: 'Julen', imageUrl: './unnamed(1).png',
      words: ['Nora', 'julen', 'gaver', 'tre barn', 'Torvald', 'hemmeligheter'],
      text: 'Nora Helmer elsket julen. Hun kom hjem med armene fulle av gaver, klar til å overraske sine tre små barn og sin mann, Torvald. Huset var fylt med latter og hemmeligheter.',
    },
    {
      mode: 'referat', title: 'Lerkefuglen', imageUrl: './unnamed(2).png',
      words: ['Torvald', 'banksjef', '«lerkefugl»', 'husholdningspenger', 'gjeld', 'sløse'],
      text: 'Torvald, som nettopp hadde blitt forfremmet til banksjef, kalte Nora sin lille «lerkefugl». Han ga henne penger til husholdningen, men advarte henne mot å sløse. «Ingen gjeld, ingen lån», sa han alltid.',
    },
    {
      mode: 'referat', title: 'Kristine kommer', imageUrl: './unnamed(3).png',
      words: ['Kristine Linde', 'venninne', 'enke', 'trenger arbeid', 'skryter', 'stor hemmelighet'],
      text: 'En dag kom en gammel venninne, Kristine Linde, på besøk. Kristine var enke og trengte arbeid. Mens de snakket, skrøt Nora av hvor lykkelig hun var, men hintet også om en stor hemmelighet.',
    },
    {
      mode: 'referat', title: 'Krogstad truer', imageUrl: './unnamed(4).png',
      words: ['Nils Krogstad', 'Torvalds bank', 'hemmelighet', 'lånet', 'forfalsket signatur', 'truer'],
      text: 'Men lykken var truet. En mann ved navn Nils Krogstad, som jobbet for Torvald, visste Noras hemmelighet. For mange år siden hadde Nora forfalsket en signatur for å låne penger. Nå truet Krogstad med å avsløre alt.',
    },
    {
      mode: 'referat', title: 'Tarantellaen', imageUrl: './unnamed(5).png',
      words: ['desperat', 'distrahere', 'tarantellaen', 'øve', 'kostymeball', 'vilt'],
      text: 'Desperat prøvde Nora å distrahere Torvald. Hun ba ham hjelpe henne med å øve på tarantellaen, en livlig dans hun skulle fremføre på et kostymeball. Hun danset vilt og ustyrlig.',
    },
    {
      mode: 'referat', title: 'Kostymeballet', imageUrl: './unnamed(6).png',
      words: ['kostymeballet', 'suksess', 'tarantellaen', 'energi', 'Krogstads trussel', 'glemmer'],
      text: 'På kostymeballet var Nora en suksess. Hun danset tarantellaen med en febrilsk energi. For et øyeblikk glemte hun Krogstads trussel og den forferdelige hemmeligheten som hang over henne.',
    },
    {
      mode: 'referat', title: 'Brevet', imageUrl: './unnamed(7).png',
      words: ['brevet', 'postkassen', 'Krogstad', 'hindre', 'Torvald', 'avslørt'],
      text: 'Men da de kom hjem, lå det et brev i postkassen fra Krogstad. Nora prøvde å hindre Torvald i å åpne det, men det var for sent. Hemmeligheten var i ferd med å bli avslørt.',
    },
    {
      mode: 'referat', title: 'Torvald raser', imageUrl: './unnamed(8).png',
      words: ['rasende', 'hykler', 'løgner', 'sitt eget rykte', 'ekteskapet', 'forstår'],
      text: 'Torvald leste brevet og ble rasende. Han kalte Nora en hykler og en løgner. Han var ikke bekymret for henne, bare for sitt eget rykte. I det øyeblikket forsto Nora at ekteskapet deres var en løgn.',
    },
    {
      mode: 'referat', title: 'Et nytt brev', imageUrl: './unnamed(9).png',
      words: ['nytt brev', 'trekker tilbake', 'overlykkelig', 'kostymet', 'snakke sammen', 'likeverdig'],
      text: 'Men så kom et nytt brev. Krogstad trakk tilbake trusselen. Torvald ble overlykkelig, men for Nora var ingenting glemt. Hun kledde av seg kostymet og satte seg ned for å snakke med Torvald for første gang som en likeverdig.',
    },
    {
      mode: 'referat', title: 'Døren smeller', imageUrl: './unnamed(10).png',
      words: ['dukke', 'finne ut hvem hun er', 'alene', 'forlater', 'barna', 'døren smeller'],
      text: 'Nora forklarte at hun ikke lenger kunne være hans dukke. Hun måtte finne ut hvem hun var, alene. Hun forlot sin mann og sine barn. Lyden av døren som smalt igjen, ga ekko i hele huset.',
    },
  ],
};
